import { createApp } from "vue";
import { createPinia } from 'pinia'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css"
import '@fortawesome/fontawesome-free/css/all.css'

import Navigation from './vue/layout/Navigation.vue';
import Breadcrumbs from './vue/layout/Breadcrumbs.vue';
import SortableTable from "./vue/components/SortableTable.vue";
import FileSystemSortableTable from "./vue/components/private-documents/FileSystemSortableTable.vue";
import FileSystemTable from "./vue/components/private-documents/FileSystemTable.vue";

import StatsPill from './vue/components/StatsPill.vue';
import StatsWidget from './vue/components/StatsWidget.vue';
import Notifications from './vue/components/Notifications.vue';
import SessionAlert from './vue/components/SessionAlert.vue';
import Table from './vue/components/Table.vue';
import Modal from './vue/components/Modal.vue';
import DocumentUpload from './vue/components/DocumentUpload.vue'
import DocumentUploadButton from './vue/components/DocumentUploadButton.vue'

import PasswordReset from './vue/elements/PasswordReset.vue';
import DeleteUser from './vue/elements/DeleteUser.vue';
import DeleteModal from './vue/elements/DeleteModal.vue';
import QrModal from './vue/elements/QrModal.vue';
import RegisterPurchaseModal from './vue/elements/RegisterPurchaseModal.vue';
import EditComplianceLinks from './vue/elements/EditComplianceLinks.vue'
import EditThirdPartyLinks from './vue/elements/EditThirdPartyLinks.vue'

import ButtonLoading from "./vue/elements/ButtonLoading";

import RejectRegister from './vue/elements/RejectRegister.vue';
import ClientBillingManagement from "./vue/components/ClientBillingManagement";
import ClientSelectorModal from "./vue/elements/ClientSelectorModal";

import RegisterCreateModal from './vue/elements/RegisterCreateModal.vue';

import AcmTable from "./vue/elements/AcmTable";
import Table2 from "./vue/components/Table2";
import AcmModal from "./vue/elements/AcmModal";
import CancelButton from "./vue/components/form/CancelButton";
import SaveButton from "./vue/components/form/SaveButton";
import InputField from "./vue/components/form/InputField";
import FieldTemplate from "./vue/components/form/FieldTemplate";
import TextareaField from "./vue/components/form/TextareaField";
import SelectField from "./vue/components/form/SelectField";
import SelectFlatField from "./vue/components/form/SelectFlatField";
import NoAccessAreaTable from "./vue/elements/NoAccessAreaTable";
import NoAccessAreaModal from "./vue/elements/NoAccessAreaModal";
import FloorplanTable from "./vue/elements/FloorplanTable";
import FloorplanModal from "./vue/elements/FloorplanModal";

import QrRegisterView from "./vue/elements/qr-register-view/QrRegisterView";

import UserPermissionForm from "./vue/elements/UserPermissionForm";
import CompileAsbestosRegisterModal from "./vue/elements/CompileAsbestosRegisterModal";

import DeleteRegister from "./vue/elements/DeleteRegister";

import consentRunner from "./cookie-consent/consent";

import PortfolioSelectorModal from "./vue/elements/PortfolioSelectorModal";
import UserForm from "./vue/elements/UserForm";
import VSelectField from "./vue/components/form/VSelectField";

import Toggler from "./vue/components/form/Toggler";


/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

window.makeElementSticky = function (element, elementOffset, setStickyCallback = () => {}, unsetStickyCallback = () => {}) {
    if (window.scrollY >= elementOffset) {
        element.classList.add('el-sticky', 'sm-el-inherit');
        setStickyCallback();
    } else {
        element.classList.remove('el-sticky', 'sm-el-inherit');
        unsetStickyCallback();
    }
}

window.toggleShowPassword = function () {
    const password = document.querySelector('.js-password'),
        passwordLabel = document.querySelector('.js-password-label'),
        passwordConfirm =  document.querySelector('.js-password-confirm');

    if(password && passwordLabel) {
        if (password.type === 'password') {
            password.type = 'text'
            passwordLabel.innerHTML = 'hide'
            if(passwordConfirm) {
                passwordConfirm.type = 'text'
            }
        } else {
            password.type = 'password'
            passwordLabel.innerHTML = 'show'
            if(passwordConfirm) {
                passwordConfirm.type = 'text'
            }
        }
    }
    password.focus()
}

window.checkRegisterType = function() {
    const clientid = document.querySelector('#client_id');
    const registerDiv = document.querySelector('#canSeeRegister');

    if(clientid && registerDiv) {
        let parameters = {
            client_id: clientid.value,
        };
        return window.axios.get('/property/new/client-subscription-check', {
            params: parameters
        }).then(function (response) {
            if(response.data.canSeeRegister === true) {
                registerDiv.style.display = 'inline-block';
            }
            else {
                registerDiv.style.display = 'none';
            }
        }).catch(error => {
            console.log(error);
        })
    }
}

/**
 * Start Vue
 */
const app = createApp({
    data: function () {
        return {
            isPasswordResetOpen: false,
            isDeleteUserOpen: false,
            isQrModalOpen: false,
            isRegisterPurchaseModalOpen: false,
            isRemoveUserOpen: false,
            isRejectRegisterOpen: false,
            isClientSelectorOpen: false,
            isPortfolioSelectorOpen: false,
            isDeleteModalOpen: false,
            deleteModalEndpoint: null,
            isRegisterCreateModalOpen: false,
            isCompileAsbestosRegisterModalOpen: false,
            isRegisterDeleteModalOpen: false,
            isCreateFolderModalOpen: false,
            action: null,
            description: null,
            alerts: {
                success: null,
                error: null
            }
        };
    },
    methods: {
        openPasswordReset: function () {
            this.isPasswordResetOpen = true;
        },
        closePasswordReset: function () {
            this.isPasswordResetOpen = false;
        },
        openDeleteUser: function () {
            this.isDeleteUserOpen = true;
        },
        closeDeleteUser: function () {
            this.isDeleteUserOpen = false;
        },
        openQrModal: function () {
            this.isQrModalOpen = true;
        },
        closeQrModal: function (type) {

            if(type === 'purchase'){
                this.openRegisterPurchaseModal();
            }
            this.isQrModalOpen = false;
        },
        openRegisterPurchaseModal: function () {
            this.isRegisterPurchaseModalOpen = true;
        },
        closeRegisterPurchaseModal: function () {
            this.isRegisterPurchaseModalOpen = false;
        },
        openRemoveUser: function () {
            this.isRemoveUserOpen = true;
        },
        closeRemoveUser: function () {
            this.isRemoveUserOpen = false;
        },
        openClientSelector: function () {
            this.isClientSelectorOpen = true;
        },
        closeClientSelector: function () {
            this.isClientSelectorOpen = false;
        },
        openPortfolioSelector: function () {
            this.isPortfolioSelectorOpen = true;
        },
        closePortfolioSelector: function () {
            this.isPortfolioSelectorOpen = false;
        },
        openRejectRegister: function () {
            this.isRejectRegisterOpen = true;
        },
        closeRejectRegister: function () {
            this.isRejectRegisterOpen = false;
        },
        openDeleteModal: function (endpoint, type) {
            this.isDeleteModalOpen = true
            this.deleteModalEndpoint = endpoint

            if (type === 'Detach') {
                this.action = 'Detach'
                this.description = 'Are you sure you want to detach?'
            } else {
                this.action = null
                this.description = null
            }
        },
        closeDeleteModal: function () {
            this.isDeleteModalOpen = false;
        },
        openRegisterCreateModal: function () {
            this.isRegisterCreateModalOpen = true;
        },
        closeRegisterCreateModal: function () {
            this.isRegisterCreateModalOpen = false;
        },
        openCompileAsbestosRegisterModal: function () {
            this.isCompileAsbestosRegisterModalOpen = true;
        },
        closeCompileAsbestosRegisterModal: function () {
            this.isCompileAsbestosRegisterModalOpen = false;
        },
        openRegisterDeleteModal: function() {
            this.isRegisterDeleteModalOpen = true;
        },
        closeRegisterDeleteModal: function() {
            this.isRegisterDeleteModalOpen = false;
        },
        openCreateFolderModal: function() {
            this.isCreateFolderModalOpen = true;
        },
        closeCreateFolderModal: function() {
            this.isCreateFolderModalOpen = false;
        },
        redirect(url) {
            if (!url) {
                window.location.reload();
                return;
            }

            window.location.href = url;
        },
        redirectToRoute(routeName, params) {
            this.redirect(window.route(routeName, params));
        },
        sendGetRequest(url, success = () => {}, error = () => {}) {
            axios.get(url)
                .then(response => {
                    this.alerts = {
                        success: { message: response.data?.success ? response.data?.message : null },
                        error: { message: !response.data?.success ? response.data?.message : null }
                    }

                    if (success instanceof Function) {
                        success()
                    }
                })
                .catch(error => {
                    this.alerts = {
                        success: { message: null },
                        error: { message: error.response?.data?.message ?? error.message }
                    }

                    if (error instanceof Function) {
                        error()
                    }
                })
        },
        toggleClientNarExclusion(client) {
            this.sendGetRequest(window.route('ajax.client.nar-toggle', client.id));
        },
        togglePropertyNarExclusion(client) {
            this.sendGetRequest(window.route('ajax.property.nar-toggle', client.id));
        }
    }
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default))

app.component('navigation', Navigation);
app.component('breadcrumbs', Breadcrumbs);

app.component('stats-pill', StatsPill);
app.component('stats-widget', StatsWidget);

app.component('session-alert', SessionAlert);
app.component('notifications', Notifications);
app.component('vue-table', Table);
app.component('modal', Modal);
app.component('button-loading', ButtonLoading);
app.component('document-upload', DocumentUpload);
app.component('document-upload-button', DocumentUploadButton);
/**
 * Custom Elements
 */
app.component('password-reset', PasswordReset);
app.component('delete-user', DeleteUser);
app.component('qr-modal', QrModal);
app.component('client-selector-modal', ClientSelectorModal);
app.component('delete-modal', DeleteModal);

app.component('register-purchase-modal', RegisterPurchaseModal);
app.component('edit-compliance-links', EditComplianceLinks);
app.component('edit-third-party-links', EditThirdPartyLinks);

app.component('reject-register', RejectRegister);

app.component('client-billing-management', ClientBillingManagement);

app.component('register-create-modal', RegisterCreateModal);

app.component('vue-table2', Table2);
app.component('cancel-button', CancelButton);
app.component('save-button', SaveButton);
app.component('field-template', FieldTemplate);
app.component('input-field', InputField);
app.component('textarea-field', TextareaField);
app.component('select-field', SelectField);
app.component('select-flat-field', SelectFlatField);

app.component('acm-table', AcmTable);
app.component('acm-modal', AcmModal);
app.component('no-access-area-table', NoAccessAreaTable);
app.component('no-access-area-modal', NoAccessAreaModal);
app.component('floorplan-table', FloorplanTable);
app.component('floorplan-modal', FloorplanModal);

app.component('qr-register-view', QrRegisterView);
app.component('user-permission-form', UserPermissionForm);
app.component('compile-asbestos-register-modal', CompileAsbestosRegisterModal);
app.component('delete-register', DeleteRegister);

app.component('portfolio-selector-modal', PortfolioSelectorModal);
app.component('user-form', UserForm);
app.component('sortable-table', SortableTable);
app.component('file-system-sortable-table', FileSystemSortableTable);
app.component('file-system-table', FileSystemTable);
app.component('v-select-field', VSelectField);

app.component('toggler', Toggler);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const pinia = createPinia()
app.use(pinia)
.use(Toast)

app.mixin({
    methods: {
        buildFormData(formData, data, parentKey) {
            if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                Object.keys(data).forEach(key => {
                    this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                });
            } else {
                const value = data == null ? '' : data;

                formData.append(parentKey, value);
            }
        }
    }
})
app.mount("#app");

consentRunner();
